
import { useSearchParams } from "react-router-dom";
import React from "react";
import { useEffect,useState } from "react";
import axios from "axios";
import { SchoolSignupContext } from "../../context/SchoolSignupContext";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import CircularProgress from "@mui/material/CircularProgress";
import TrialExpiredModal from "../../components/TrialExpiredModal";
import {
  checkAndBlockIfTrialExpired,
  verifySchoolSubscriptionBlocked,
} from "../../utils/schoolSubscription";
import { useTrialExpiredModal } from "../../hooks/useTrialExpiredModal";


const GoogleRoute = () => {
    // alert("GoogleRoute")
    const baseURL = process.env.REACT_APP_BASE_URL;
     const navigate =  useNavigate();
    
    const { signupData } = React.useContext(SchoolSignupContext);
    const [schoolType] = useState(signupData?.schoolType ? signupData?.schoolType : "");

    const [searchParams] = useSearchParams();
    const type = searchParams.get("code");
    const {
      showTrialExpiredModal,
      setShowTrialExpiredModal,
      handleTrialRenew,
      handleTrialCancel,
      cancelLoading,
    } = useTrialExpiredModal(signupData);

       async function decodeJWT(token) {
          const payload = token.split('.')[1];
          return JSON.parse(atob(payload));
        }
        

        const callTokenRefresh = async (token) => {
          try {
            const response = await fetch(
              `${baseURL}/user/tokenRefresh?masterTypeid=${schoolType?schoolType:""}`,
              {
                method: "GET",
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              }
            );
      
            if (!response.ok) {
              throw new Error(`HTTP error! Status: ${response.status}`);
            }
      
            const data = await response.json();
          return data; // 👈 MUST return data
          } catch (error) {
            console.error("❌ Error calling tokenRefresh API:", error);
          }
        };

            const handleUpdateSchool = async (user_Id,decodedTokenOld) => {
              const apiUrl = `${baseURL}/school/updateSchool`;
          
              const data = {
                schoolId: String(signupData.schoolId),
                userId: String(user_Id),
                schoolName: String(signupData.schoolName),
                code: String(signupData.schoolCode),
                // code:"2344",
                masterTypeid: schoolType?schoolType:"",


              };
          
              try {
                const response = await axios.post(apiUrl, data, {
                  headers: {
                    'Content-Type': 'application/json',
                  },
                });
          
        

                const schoolContext = {
                  ...signupData,
                  schoolCode: signupData.schoolCode ?? signupData.verificationCode,
                };

                if (
                  checkAndBlockIfTrialExpired(response.data, schoolContext) ||
                  (response.data.code === 200 &&
                    (await verifySchoolSubscriptionBlocked(baseURL, schoolContext)))
                ) {
                  localStorage.removeItem("access_token");
                  setShowTrialExpiredModal(true);
                  return;
                }

                if(response.data.code === 200) {
                  // toast.error(response.data.message);
                      const storedPath = localStorage.getItem("before_school_path");

                        if (storedPath && storedPath !== "null" && storedPath !== "undefined") {
                            const refreshToken = await callTokenRefresh(decodedTokenOld);
                            const newToken = refreshToken?.data;
                            if (newToken) {
                              localStorage.setItem("access_token", newToken);
                            }
                            const decodedToken = newToken ? await decodeJWT(newToken) : null;
                            const masterTypeid = decodedToken?.masterTypeid;
                            if (masterTypeid === 1) {
                              localStorage.setItem("school_type", "tft");
                            } else {
                              localStorage.setItem("school_type", "");
                            }
                            const linkMasterTypeId = storedPath.includes("masterTypeId=") ? new URLSearchParams(storedPath.split("?")[1] || "").get("masterTypeId") : null;
                            if (linkMasterTypeId !== null && linkMasterTypeId !== "" && decodedToken !== null && String(masterTypeid) !== String(linkMasterTypeId)) {
                              localStorage.removeItem("before_school_path");
                              toast.warning("This chat was shared from a different school type. You can only view chats shared within your school type.");
                              navigate("/", { replace: true });
                            } else {
                              navigate(storedPath);
                            }
                          } else {
                            let refreshToken= await callTokenRefresh(decodedTokenOld);
                            localStorage.setItem("access_token", refreshToken?.data);
                          
                            // Decode token
                            const decodedToken = await decodeJWT(refreshToken?.data);
                            console.log("decodedToken",decodedToken)
                            const userId = decodedToken.user_id;
                            const masterTypeid = decodedToken.masterTypeid;
                            console.log("userId",userId)
                            // if(userId==367 || 222){
                              if(masterTypeid === 1){
                          
                             console.log("userId id is persent",userId)
                            localStorage.setItem("school_type", "tft");
                                 window.location.href = "/";
                                        //  navigate("/", { state: { email } });
                                        //  window.location.reload(); // refresh the page
                        
                        
                        
                        
                            }else{
                              console.log("userId not tft id is persent",userId)
                        
                            localStorage.setItem("school_type","");
                                 window.location.href = "/";
                                        //  navigate("/", { state: { email } });
                                        //  window.location.reload(); // refresh the page
                        
                        
                        
                            }

                            // navigate("/");  // Default redirect
                          }


                }
                else{
                  if (checkAndBlockIfTrialExpired(response.data, schoolContext)) {
                    localStorage.removeItem("access_token");
                    setShowTrialExpiredModal(true);
                    return;
                  }
                  localStorage.removeItem("access_token");
                  toast.error(response.data.message);
                  navigate("/landingpage");
                }
              } catch (error) {
                if (error.response) {
                  // Server responded with an error status code
                  toast.error(`❌ Error: ${error.response.data.message || 'Update failed'}`);
                  console.error('Error Response:', error.response.data);
                } else {
                  // Network error or no response
                  toast.error('❌ Network error!');
                  console.error('Error:', error.message);
                }
              }
            };






useEffect(() => {
  if (type) {

      const runAsync = async () => {
          try {
              localStorage.setItem("access_token", type);

              const decodedToken = await decodeJWT(type);
              const userId = decodedToken.user_id;

              await handleUpdateSchool(userId,type);
              // localStorage.setItem("access_token", type);
              // window.location.href = "/";
          } catch (error) {
              console.error("Error in useEffect async call:", error);
          }
      };

      runAsync();
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [type]);

return(
    <>
             <TrialExpiredModal
               open={showTrialExpiredModal}
               onActivatePlan={handleTrialRenew}
               onCancelSubscription={handleTrialCancel}
               cancelLoading={cancelLoading}
             />
             <div style={{display: "flex", justifyContent: "center", 
              alignItems: "center", height: "100vh", color: "rgb(44 104 161)", backgroundColor: "rgba(0, 0, 0, 0.4)"}}>     
                      <CircularProgress color="inherit" />
             </div>    
    </>
);
}
export default GoogleRoute;